var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRupee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.918 5.10938L11.3789 6.96094H0.503906L1.04297 5.10938H11.918ZM7.04297 18L0.84375 10.7578L0.832031 9.30469H3.69141C4.51953 9.30469 5.20312 9.16797 5.74219 8.89453C6.28906 8.61328 6.69922 8.23438 6.97266 7.75781C7.24609 7.28125 7.38281 6.74609 7.38281 6.15234C7.38281 5.48828 7.25391 4.90625 6.99609 4.40625C6.73828 3.89844 6.33203 3.50391 5.77734 3.22266C5.23047 2.93359 4.51172 2.78906 3.62109 2.78906H0.527344L1.07812 0.9375H3.62109C4.98047 0.9375 6.10156 1.14453 6.98438 1.55859C7.875 1.96484 8.53906 2.55859 8.97656 3.33984C9.41406 4.12109 9.63281 5.06641 9.63281 6.17578C9.63281 7.12891 9.44922 7.98438 9.08203 8.74219C8.72266 9.49219 8.125 10.082 7.28906 10.5117C6.46094 10.9414 5.34375 11.1562 3.9375 11.1562L9.70312 17.8594V18H7.04297ZM11.918 0.9375L11.3789 2.78906H2.61328L3.15234 0.9375H11.918Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/Rupee.3b14f4807ede52c821e9c2ae3a6e682b.svg";
export { ForwardRef as ReactComponent };